import { atom } from 'jotai';

import { BookingPhotoRequirement } from '../_graphql/queryBookingPhotoRequirements';

// 🔘🔘🔘 PLAIN ATOMS - Photo State
export const $photoRequirements = atom<BookingPhotoRequirement[]>([]);
